import styled, { css, DefaultTheme } from 'styled-components';
import { Field as UnstyledField } from 'formik';

type LabelProps = {
  required?: boolean;
};

type SelectProps = {
  $isValid?: boolean;
  variant: 'primary' | 'secondary';
};

export const Select = styled(UnstyledField)<SelectProps>`
  ${({ theme, variant, $isValid = true }) => css`
    font-family: 'Roboto';
    font-size: 1.6rem;
    line-height: 2.6rem;
    font-weight: ${variant === 'primary' ? 400 : 600};
    color: ${variant === 'primary'
      ? theme.colors.neutralSilver80
      : theme.colors.neutralSilver100};

    width: 100%;

    // custom arrow
    -webkit-appearance: none;
    -moz-appearance: none;
    background: ${theme.colors.white};
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" fill="rgba(182,188,200,1)"/></svg>');
    background-repeat: no-repeat;
    background-position: top 14px right 12px;

    outline-color: ${$isValid
      ? theme.colors.neutralSilver10
      : theme.colors.statusDanger20};
    border: 1px solid
      ${$isValid ? theme.colors.neutralSilver10 : theme.colors.statusDanger20};
    border-radius: 4px;
    padding: 12px 20px 12px 16px;

    &:disabled {
      background-color: ${theme.colors.neutralSilver10};
    }

    // style select placeholder
    &:has(option[disabled]:checked) {
      color: ${theme.colors.neutralSilver60};
      font-weight: 400;
    }

    option {
      color: ${theme.colors.neutralSilver90};
    }

    option[disabled] {
      color: ${theme.colors.neutralSilver60};
    }

    svg {
      color: ${theme.colors.neutralSilver20};
    }

    &:hover {
      border: 1px solid ${theme.colors.purple50};
    }

    &:active,
    &:focus {
      border: 1px solid ${theme.colors.brandPrimary100};
      outline: 1px solid ${theme.colors.brandPrimary30};
      outline-offset: 1px;
    }
  `}
`;

const labelModifiers = {
  required: (theme: DefaultTheme) => css`
    &::after {
      content: '*';
      margin-left: 8px;
      vertical-align: middle;
      color: ${theme.colors.statusDanger30};
    }
  `,
};

export const Label = styled.label<LabelProps>`
  ${({ theme, required }) => css`
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.neutralSilver70};

    display: block;

    margin-bottom: 8px;

    ${required && labelModifiers.required(theme)}
  `};
`;
